import './competences.scss';
import React, { useState } from 'react';
import Resto from './resto';
import Formation from './formation';
import Informatique from './informatique';
import Electrique from './electrique';

function Competences() {

    let [myButton, setMyButton] = useState('Voir mes compétences en informatique');
    let [content, setContent] = useState(<Electrique/>)

    const handleClick = () => {
        setTimeout(() => {
            if(myButton === 'Voir mes compétences en informatique'){
                setMyButton('Voir mes compétences en formation')
                setContent(<Informatique/>)
            }else if (myButton === 'Voir mes compétences en formation'){
                setMyButton('Voir mes compétences en restauration')
                setContent(<Formation/>)
            }else if (myButton === 'Voir mes compétences en restauration'){
                setMyButton('Voir mes compétences électriques')
                setContent(<Resto/>)
            }else {
                setMyButton('Voir mes compétences en informatique')
                setContent(<Electrique/>)
            }
        }, 400)
    }
    return(
        <section id="skills">
            <h2 className="fs-40">Compétences</h2>
          <button className="cta" key={myButton} onClick={handleClick} >
            <span>{myButton}</span>
            <img className="white-arr" src="/img/icons/white-arrow.svg" />
          </button>
            {content}
        </section>
    )
}

export default Competences
